var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "accordion" } }, [
    _c("div", { staticClass: "accordion-div" }, [
      _c(
        "div",
        {
          staticClass: "accordion-body",
          class: { "is-folded": _vm.is_folded }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.is_folded
        ? _c(
            "div",
            { staticClass: "accordion-ctrl", on: { click: _vm.spread } },
            [_vm._v("▼")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.is_folded
        ? _c(
            "div",
            { staticClass: "accordion-ctrl", on: { click: _vm.fold } },
            [_vm._v("▲")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }